import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Flex, Button, Text, SimpleGrid, Alert, AlertIcon } from '@chakra-ui/react';
import InputSearch from '../../../shared/inputSearch/InputSearch';
import Pagination from '../../../shared/pagination/Pagination';
import Breadcrumbs from '../../../shared/breadcrumbs/Breadcrumbs';
import ContentCreatorsTable from './ContentCreatorsTable';
import CreateModal from './actions/CreateModal';
import UpdateModal from './actions/UpdateModal';
import DeleteModal from './actions/DeleteModal';
import { getContentCreators } from '../../../../store/contentCreators/contentCreatorsSlice';
import { RulesWrapper } from '../rules/RulesStyle';
import theme from '../../../global/theme';

const ContentCreators = () => {
  const dispatch = useDispatch();
  const contentCreators = useSelector(state => state.contentCreators);
  const [page, setPage] = useState(1);
  const [query, setQuery] = useState('');
  const [filter] = useState(JSON.stringify({}));
  const [showCreate, setShowCreate] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  useEffect(() => { dispatch(getContentCreators({ page, query, filter })); }, [dispatch, page, query, filter]);

  return (
    <RulesWrapper>
      <Breadcrumbs currentPage="صناع المحتوى" pages={[{ name: 'لوحة التحكم', path: '/admin' }]} />
      {contentCreators.errors.length > 0 && (
        <Alert status="error" variant="left-accent" marginBottom={8}>
          <AlertIcon />
          {contentCreators.errors.map((e, i) => <Text key={i}>{e?.msg}</Text>)}
        </Alert>
      )}
      <SimpleGrid columns={{ sm: 1, md: 2 }} justifyContent="space-between">
        <Flex marginBottom={8}>
          <Button bg="red.600" fontWeight="bold" fontSize={18} marginInlineEnd={4} color="white"
            _hover={{ bg: 'red.600' }} onClick={() => setShowCreate(true)}>
            إضافة صانع محتوى
          </Button>
        </Flex>
        <Flex marginBottom={8} justifyContent="flex-end">
          <InputSearch isLoading={contentCreators.isLoading} handleSearch={(q) => setQuery(q)} />
        </Flex>
      </SimpleGrid>
      {contentCreators.data?.itemsCount > 0 ? (
        <ContentCreatorsTable data={contentCreators.data.data} page={page}
          handleUpdate={(el) => setShowUpdate(el)} handleDelete={(el) => setShowDelete(el)} />
      ) : (
        <Flex textAlign="center" bg={theme.light} boxShadow={theme.shadow} height={200}
          alignItems="center" justifyContent="center" borderRadius={4}>
          <Text fontSize={18} color="gray.300" fontWeight="bold">لا يوجد صناع محتوى</Text>
        </Flex>
      )}
      <Flex justifyContent="flex-end">
        <Pagination page={page} itemsCount={contentCreators.data?.itemsCount ?? 0} onChange={setPage} />
      </Flex>
      {showCreate && <CreateModal onClose={() => setShowCreate(false)} />}
      {showUpdate && <UpdateModal data={showUpdate} onClose={() => setShowUpdate(false)} />}
      {showDelete && <DeleteModal data={showDelete} onClose={() => setShowDelete(false)} />}
    </RulesWrapper>
  );
};

export default ContentCreators;
